

















































































































































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import uuifComponent from '@/shared/uuifComponent';
import { TableColumnConfig, TableData, TableEntry, ColumnsAdjustRequestData, SortedColumnInfo, ColumnSortRequestData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { CreateElement, VNode } from 'vue';
import { SwContentToolbar, SwContentToolbarExpand } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { DropMenuItem, SwDropMenu } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwExpandableTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import ExportcsvService from '@/shared/msw-exportcsv.service';
import { PageTitleConfig } from '../../shared/msw-app-title/type';
import moment from 'moment';

const cssPrefix = 'subscription-report';

@Component({
  components: {
    ...uuifComponent,
    MswAppTitle,
    SwContentToolbarExpand,
    SwDropMenu,
    SwIconButton,
    SwExpandableTextfield,
    SwContentToolbar,
  },
})
export default class SubscriptionReport extends SwExtendedVue {
  cssPrefix =  cssPrefix;

  get filterItems(): DropMenuItem[] {
    return [
      {
        id: 'SerialNumber',
        content: this.$t('products.serialnumber')
        .toString(),
      },
      {
        id: 'FriendlyName',
        content: this.$t('products.friendlyName')
        .toString(),
      },
      {
        id: 'Model',
        content: this.$t('report.model')
        .toString(),
      },
      {
        id: 'productGroupName',
        content: this.$t('products.tenantname')
        .toString(),
      },
      {
        id: 'RegDate',
        content: this.$t('report.regstrd')
        .toString(),
      },
      {
        id: 'FirmwareVersion',
        content: this.$t('products.firmwareversion')
        .toString(),
      },
      {
        id: 'LastPingDate',
        content: this.$t('report.lstPingDate')
        .toString(),
      },
    ];
  }

  exportMenuItems: DropMenuItem[] = [
    { id: 'csv', content: 'Export CSV' },
    { id: 'xls', content: 'Export XLS' },
  ];

  menuOpened: boolean = false;
  exportMenuOpened: boolean = false;
  reportData : TableData[] = [];
  tempReportData: any = [];
  repName: string = 'BuyNow';
  reportHeading: string = '';
  reportColumnList: any[] = [];
  sortedColumns: SortedColumnInfo[] = [];
  address : string = '';
  company : string = '';
  citystate : string = '';
  country : string = '';

  adjustedColumns: ColumnsAdjustRequestData = {};
  textExpanded: boolean = false;
  filterKeys: any = ['SerialNumber', 'FriendlyName', 'Model', 'productGroupName', 'DtRegDate'];
  globalSearchValue : string = '';
  searchInputChips: any[] = [];
    // filter
  filterSearchConfig: any = {
    isEnableFilterSearch: false,
    filterSearchKey:'',
    filterSearchOption:'',
    filterSearchLabel:'',
  };

  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: 'Claimed Assest',
      pageParentName: 'Reports',
    };
  }

  reportColumnsConfig : TableColumnConfig[] = [{
    key : 'SerialNumber',
    dataKey: 'SerialNumber',
    title : this.$t('quote.serialNo')
    .toString(),
    sorter: true,
    // tslint:disable-next-line:no-unused
    render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
      return (
       <div>
        <a style="color: #47afe8;" onClick={() => this.serialNumberClick(data.entry)}>{ data.entry.SerialNumber }</a>
      </div>
    ) as VNode;
    },
    width : 130,
  },
  {
    key : 'FriendlyName',
    dataKey : 'FriendlyName',
    title : this.$t('products.friendlyName')
    .toString(),
    width : 200,
    sorter: true,
  },
  {
    key : 'Model',
    dataKey : 'Model',
    title : this.$t('report.model')
    .toString(),
    width : 200,
    sorter: true,
  },
  {
    key : 'productGroupName',
    dataKey : 'productGroupName',
    title : this.$t('products.tenantname')
    .toString(),
    width : 200,
    sorter: true,
  },
  {
    key : 'DtRegDate',
    dataKey : 'RegDate',
    title : this.$t('report.regstrd')
    .toString(),
    width : 100,
    sorter: true,
  },
  {
    key: 'FirmwareVersion',
    dataKey: 'FirmwareVersion',
    title: this.$t('products.firmwareversion')
    .toString(),
    width: 100,
    sorter: true,
  },
  {
    key: 'LastPingDate',
    dataKey: 'LastPingDate',
    title: this.$t('report.lstPingDate')
    .toString(),
    width: 150,
    sorter: true,
  }];

  onRequestSorting(data: ColumnSortRequestData) {
    /** for now, we only support single-column sorting */
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.cancel) {
        this.sortedColumns.splice(index, 1);
        this.sortedColumns.push({
          colKey: data.colKey,
          ascending: !!data.ascending,
        });
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  created() {
    this.initFromRoute();
  }

  @Watch('$route.query.repName')
  onRepNameQueryChange() {
    this.initFromRoute();
  }

  initFromRoute() {
    if (this.$router.currentRoute.query.repName === 'CAP') {
      this.repName = 'CAP';
      this.reportHeading = this.$t('report.claimedstatus')
      .toString();
    } else {
      this.repName = 'BuyNow';
      this.reportHeading = this.$t('report.reportstatus')
      .toString();
    }
    this.getUserDetailsAndReportDetails(this.snbUser);
  }

  get snbUser() {
    return this.$store.getters.getUserId;
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  getUserDetailsAndReportDetails(userId: any) {
    const request = {
      username: this.snbUser,
      tenant: '',
      repName: this.repName,
    };
    Promise.all([
      this.$store.dispatch('SubscriptionReportStoreModule/getSubscrReport', request),
      this.$store.dispatch('SubscriptionReportStoreModule/getUserDetails', userId),
    ])
    .then((response : any) => {
      if (response[0] && response[0].content.colnames) {
        this.reportColumnList = response[0].content.colnames.split('^');
        this.reportColumnList.forEach((ele : any, index : any) => {
          if (index < 22) {
            this.reportColumnsConfig.push({
              key : `col${(index + 1)}ServiceExpiryDate`,
              dataKey : `col${(index + 1)}ServiceExpiryDate`,
              title : ele,
              sorter: true,
              render: (h: CreateElement, data: { entry: TableEntry }): VNode => {// tslint:disable-line
                return (
                    <div>
                      {data.entry[`col${(index + 1)}ServiceExpiryDate`] !== undefined && data.entry[`col${(index + 1)}ServiceExpiryDate`] !== 'N/A' ? <a style="color: #47afe8;" onClick={() => this.otherColumnClick(data.entry)}>{ data.entry[`col${(index + 1)}ServiceExpiryDate`] }</a>
                      : data.entry[`col${(index + 1)}ServiceExpiryDate`] }
                    </div>
                  ) as VNode;
              },
            });
            this.filterKeys.push(`col${(index + 1)}ServiceExpiryDate`);
            this.filterItems.push({ id: `col${(index + 1)}ServiceExpiryDate`, content: ele });
          }
        });
      }
      this.assignReportResponse(response[0]);
      this.address = response[1].content.companyAddress;
      this.company = response[1].content.companyName;
      if (response[1].content.companyAddress1) {
        this.address += `, ${response[1].content.companyAddress1}`;
      }
      this.citystate = `${response[1].content.companyCity} , ${response[1].content.companyState}`;
      if (response[1].content.companyState === '') {
        this.citystate += response[1].content.companyProvince;
      }
      this.country = `${response[1].content.companyCountryName} , ${response[1].content.companyZipCode}`;
    })
    .catch((err: any) => {
      console.warn(err);
    });
  }

  getReportDetails() {
    const request = {
      username: this.snbUser,
      tenant: '',
      repName: this.repName,
    };
    this.$store.dispatch('SubscriptionReportStoreModule/getSubscrReport', request)
    .then((response : any) => {
      this.assignReportResponse(response);
    })
    .catch((err: any) => {
      console.warn(err);
    });
  }

  reload() {
    this.onRemoveAllFilters();
    this.getReportDetails();
  }

  onSelectMultiItem(type: any) {
    this.menuOpened = !this.menuOpened;
    this.globalSearchValue = '';
    const isExistingChip = this.searchInputChips?.find((el: any) => el.column === type);
    if (!isExistingChip) {
      this.filterSearchConfig.isEnableFilterSearch = true;
      this.filterSearchConfig.filterSearchOption = type;
      this.filterSearchConfig.filterSearchLabel = this.filterItems.filter(ele => ele.id.toString() === type)[0].content;
    }
  }

  handleSearchFilter() {
    this.applyAllFilters();
  }

  removeInputChip(index: any) {
    this.searchInputChips.splice(index, 1);
    this.applyAllFilters();
  }

  addFilterKey(event: any) {
    if (event.code === 'Enter' && this.filterSearchConfig.filterSearchKey !== '') {
      this.searchInputChips.push({ value: this.filterSearchConfig.filterSearchKey.trim(), column: this.filterSearchConfig.filterSearchOption });
      this.applyAllFilters();
      this.filterSearchConfig.filterSearchKey = '';
      this.filterSearchConfig.filterSearchLabel = '';
      this.filterSearchConfig.isEnableFilterSearch = false;
    }
  }

  applyAllFilters() {
    const data: any[] = [...this.tempReportData];
    let filteredData : any[] = [];
    this.$store.commit('startLoading');
    if (this.globalSearchValue) {
      this.filterItems.forEach((column: any) => {
        filteredData.push(...data.filter((element: any) => {
          return element[column.id]?.indexOf(this.globalSearchValue) > -1;
        }));
      });
    } else {
      if (this.searchInputChips.length === 0) {
        this.reportData = [...data];
        this.$store.commit('stopLoading');
        return;
      }
      filteredData = data.filter((item) => {
        for (const filter of this.searchInputChips) {
          if (item[filter.column] !== filter.value) {
            return false;
          }
        }
        return true;
      });
    }
    this.reportData = [...filteredData];
    this.$store.commit('stopLoading');
  }

  onRemoveAllFilters() {
    this.globalSearchValue = '';
    this.filterSearchConfig = {
      isEnableFilterSearch: false,
      filterSearchKey:'',
      filterSearchOption:'',
      filterSearchLabel:'',
    };
    this.searchInputChips = [];
    this.applyAllFilters();
  }

  assignReportResponse(response : any) {
    this.tempReportData = [];
    this.reportData = [];
    this.reportData = response.content.Records.map((ele : any, index : any) => {
      ele._key = index.toString();
      return ele;
    });
    this.tempReportData = this.reportData;
    this.$store.commit('stopLoading');
  }

  serialNumberClick(val : any) {
    this.$router.push({ path: `/m/feature/products?serialNumber=${val.SerialNumber}` })
    .catch((routeError: any) => {
      console.warn(routeError);
    });
  }

  otherColumnClick(val: any) {
    this.$router.push({ path: `/m/feature/products?serialNumber=${val.SerialNumber}&tab=licenses` })
    .catch((routeError: any) => {
      console.warn(routeError);
    });
  }

  onChangeExport(itemId: string) {
    if (itemId === 'csv') {
      this.exportCsv();
    } else {
      this.exportXls();
    }
  }

  exportCsv() {
    ExportcsvService.export(this.mapToExport(this.reportData), 'Report.csv');
  }

  exportXls() {
    ExportcsvService.export(this.mapToExport(this.reportData), 'Report.xlsx');
  }

  // asf
  mapToExport(csvData: any[]) {
    let filterJson: any[] = [];
    const itemHeader: string[] = [];
    this.reportColumnsConfig?.map((entry: TableColumnConfig) => {
      if (entry?.key === 'SerialNumber') {
        itemHeader.push('SERIAL NUMBER'); // Manipulating to match with angular
      } else if (entry?.key === 'DtRegDate') {
        itemHeader.push('REGISTERED DATE'); // Manipulating to match with angular
      } else {
        itemHeader.push(entry?.title?.toString().toUpperCase() || '');
      }
    });
    const tempJson: any = [{}, itemHeader];
    csvData?.map((dataItem:any) => {
      const obj = {};
      this.reportColumnsConfig?.forEach((item) => {
        if (item?.dataKey) {
          if (item?.dataKey === 'RegDate') {
            // @ts-ignore
            obj[item.title] = dataItem[item?.dataKey] && moment(dataItem[item?.dataKey])?.format('MMM DD YYYY');
          } else if (item?.dataKey === 'LastPingDate') {
            // @ts-ignore
            obj[item.title] = dataItem[item?.dataKey] && moment(dataItem[item?.dataKey])?.format('MMM DD YYYY');
          } else {
            // @ts-ignore
            obj[item.title] = dataItem[item?.dataKey];
          }
        }
      });
      tempJson.push(obj);
    });
    filterJson = filterJson.concat(tempJson);
    return filterJson;
  }

  printExport() {
    // const reportDataPrint = this.mapToExport(this.reportData);
    let result = `<html><head></head><body><link id='lnkstyle' rel='stylesheet'href='https://www.mysonicwall.com/App_Themes/Blue/Blue.css' type='text/css'><title>mySonicWALL.com - Subscription report - Printable version</title>
    <table width='900' cellspacing='0' cellpadding='0' border='0'><tbody><tr><td width='27'><img id='space1' src='https://www.mysonicwall.com/App_Themes/Blue/images/spacer.gif' style='width:27px;border-width:0px;'>
    </td><td><table width='100%' cellspacing='0' cellpadding='0' border='0' align='center'><tbody>
    <tr><td class='style1'><input name='imgfooterlogo' id='imgfooterlogo' src='https://www.mysonicwall.com/images/generic-footer-thin.jpg'
    style='border-width: 0px;' type='image'></td><td align='right'><table width='100%' cellspacing='0'
    cellpadding='0' border='0' align='center'><tbody><tr><td align='right'><a href='#' id='printsec'
    onclick='var obj = document.getElementById(&quot;imgfooterlogoPrinter&quot;);
    var objlnk = document.getElementById(&quot;printsec&quot;);
    if (obj.style.visibility == &quot;hidden&quot;) { obj.style.visibility =&quot;visible&quot;;objlnk.style.visibility =&quot;visible&quot;; }
    else { obj.style.visibility = &quot;hidden&quot;;objlnk.style.visibility = &quot;hidden&quot;; };window.print();if (obj.style.visibility == &quot;hidden&quot;)
    { obj.style.visibility = &quot;visible&quot;; objlnk.style.visibility = &quot;visible&quot;;} else { obj.style.visibility = &quot;hidden&quot;;  objlnk.style.visibility = &quot;hidden&quot;;};'>
    <input name='imgfooterlogoPrinter' id='imgfooterlogoPrinter' src='https://www.mysonicwall.com/App_Themes/Blue/images/Printer.gif' style='border-width: 0px;' type='image'><br>
    <span id='lblPrint' title='Print this page'>Print this page</span></a></td></tr></tbody></table></td></tr></tbody></table><br><div><img id='dot3' src='https://www.mysonicwall.com/images/dotted_750.GIF' style='height:1px;width:900px;border-width:0px;'></div>`;
    result += "<br><br><div id='userinfo' style='width:500px;'><span class='regbld'><span id='lbluserinfo' class='subheader'>User Details: </span> </span><br><br>";
    result += "<table width='500' cellspacing='0' cellpadding='0'><tbody>";
    // tslint:disable-next-line:max-line-length
    result += `<tr><td><span id='lblusernametext' class='main_contents'>Username</span>  </td> <td> <span id='lblusernameval' class='main_contents'>: ${this.snbUser}'</span></td></tr>`;
    // tslint:disable-next-line:max-line-length
    result += `<tr><td><span id='lblcompanytext' class='main_contents'>Company</span>  </td><td><span id='lblcompanyval' class='main_contents'>: ${this.company} + '</span>  <br></td> </tr>`;
    result += `<tr><td valign='top'><span id='lblstreetaddresstext' class='main_contents'>Street Address</span> </td> <td><span id='lblstreetaddressval' class='main_contents'>: ${this.address}</span></td></tr>`;
    // tslint:disable-next-line:max-line-length
    result += `<tr><td><span id='lblcitystatetext' class='main_contents'>City, State</span> </td> <td><span id='lblcitystateval' class='main_contents'>: " ${this.citystate}</span></td></tr>`;
    result += `<tr><td><span id='lblcountrypostaltext' class='main_contents'>Country, Postal Code</span>  </td> <td><span id='lblcountrypostalval' class='main_contents'>: ${this.country}</span></td></tr>`;
    result += '</tbody></table><br><br></div>';

    result += '</td></tr></tbody></table>';
    result += "<table width='900' cellspacing='0' cellpadding='0' border='0'><tr><td width='27'><img id='space1' src='https://www.mysonicwall.com/App_Themes/Blue/images/spacer.gif' style='width:27px;border-width:0px;'></td><td>";

    result += "<table width='1400'  border='1' style='border-collapse:collapse'><tr><th style='width:2%;'></th>";
    this.filterItems.forEach((ele : any) => {
      result += `<th style='width:10%;'><span  class='subheader'>${ele.content}</span></th>`;
    });
    result += '</tr>';
    this.reportData.forEach((ele: any, index: any) => {
      result += `<tr><td>${index + 1}</td>`;
      this.filterItems.forEach((item: any) => {
        const data = ele[`${item.id}`];
        result += `<td style='margin-left: 5px;'>${data ? data : ''}</td>`;
      });
      result += '</tr>';
    });
    result += '</table></td></tr></table>';
    result += `<br><table width='900' cellspacing='0' cellpadding='0' border='0'><tbody><tr><td width='27'>
    <img id='space1' src='https://www.mysonicwall.com/App_Themes/Blue/images/spacer.gif' style='width:27px;border-width:0px;'></td>
    <td><p><img id='dot3' src='https://www.mysonicwall.com/images/dotted_750.GIF' style='height:1px;width:900px;border-width:0px;'>
    <br><br><span id='lblsupporttext' class='subheader'>SONICWALL CUSTOMER SUPPORT</span><br>
    <span id='lblhelplinetext' class='main_contents'>1.888.793.2830</span><br><a id='hlemail' href='mailto:servicesales@sonicwall.com'>
    servicesales@sonicwall.com</a></p></td></tr></tbody></table><br>`;
    result += '</body></html>';

    const w = window.open();
    w!.document.body.innerHTML = result;

  }
}
